import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
    selector: '[translate]',
    standalone: false
})
export class TranslateKeyAttributeDirective implements OnInit {
  @Input('translate') translateKey: string;
  translateKeyAttribute: string = '';
  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.setTranslateKey();
  }

  setTranslateKey() {
    this.translateKeyAttribute = this.translateKey;
    if (!this.translateKeyAttribute) {
      this.translateKeyAttribute = this.el.nativeElement.textContent.trim();
    }

    if (this.translateKeyAttribute) {
      this.el.nativeElement.setAttribute(
        'translate-key',
        this.translateKeyAttribute
      );
    }
  }
}
